/**
 * Configuration d'exécution : la même image de l'interface sert la démo et la production.
 * Caddy répond à /config.json avec les valeurs de l'instance ; en dev, le fichier public/config.json.
 */
export interface RuntimeConfig {
  keycloakUrl: string;
  realm: string;
  clientId: string;
}

const fallback: RuntimeConfig = { keycloakUrl: 'http://localhost:8080', realm: 'manuia', clientId: 'manuia-web' };

export async function loadRuntimeConfig(): Promise<RuntimeConfig> {
  try {
    const response = await fetch('/config.json', { cache: 'no-store' });
    if (!response.ok) return fallback;
    const json = (await response.json()) as Partial<RuntimeConfig>;
    return { ...fallback, ...json };
  } catch {
    return fallback;
  }
}
